import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Award, CheckCircle, Target, FolderCheck } from "lucide-react";
import { profileService } from "../services/profile";

const PublicProfile = () => {
  const { id } = useParams();

  const { data: profile, isLoading } = useQuery({
    queryKey: ["public-profile", id],
    queryFn: () => profileService.getPublicProfile(id),
  });

  if (isLoading) return <div>Loading...</div>;

  const stats = [
    { label: "Performance Score", value: profile.performanceScore || 0, icon: Award, color: "text-yellow-600 bg-yellow-100" },
    { label: "Tasks Completed", value: profile.tasksCompleted || 0, icon: CheckCircle, color: "text-green-600 bg-green-100" },
    { label: "Success Rate", value: `${profile.successRate || 0}%`, icon: Target, color: "text-blue-600 bg-blue-100" },
    { label: "Projects Completed", value: profile.projectsCompleted || 0, icon: FolderCheck, color: "text-purple-600 bg-purple-100" },
  ];

  return (
    <div className="p-6">
      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
            {profile.name?.[0]?.toUpperCase()}
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{profile.name}</h1>
            <span className="text-sm text-gray-500 capitalize px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full">{profile.role}</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <div key={stat.label} className="bg-white shadow rounded-lg p-5">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${stat.color}`}>
                <stat.icon className="w-5 h-5" />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                <p className="text-xs text-gray-500">{stat.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PublicProfile;
